import React from 'react'
import { IntroductionCardProps } from './types'
import styles from './Introduction.module.css'

export default function IntroductionCard({
    stepImageSp,
    stepImageSpAlt,
    image,
    imageAlt,
    title,
    description,
}: IntroductionCardProps) {
    return (
        <li>
            <img
                className={styles.introductionStepSp}
                src={stepImageSp}
                alt={stepImageSpAlt ?? ''}
            />
            <img src={image} alt={imageAlt ?? ''} />
            <h2>{title}</h2>
            <p>{description}</p>
        </li>
    )
}
